import Icon from 'veui/components/Icon'

Icon.register({
  file: {
    paths: [
      {
        d: 'M28 4H8a2 2 0 00-2 2v36c0 1.1.9 2 2 2h32a2 2 0 002-2V17h-9.2a4.8 4.8 0 01-4.8-4.8V4zm11.97 9L32 6.1v6.1c0 .44.36.8.8.8h7.17zM8 0h22.33a2 2 0 011.31.49l13.67 11.84a2 2 0 01.69 1.52V42a6 6 0 01-6 6H8a6 6 0 01-6-6V6a6 6 0 016-6zm4.63 29.33a2 2 0 110-4h23.74a2 2 0 110 4H12.63zm.12-12a2 2 0 110-4h10.62a2 2 0 110 4H12.75z'
      }
    ],
    width: '48',
    height: '48'
  }
})
